import "./Digital_Media_Services_Inner.css";
import React, { useEffect, useState } from "react";
import Title_Component from "./Title_Component/Title_Component";
import Breadcrumbs_Holder from "../../Common_Component/Breadcrumbs_Holder/Breadcrumbs_Holder";
import { useParams } from "react-router-dom";
import How_It_Works from "./How_It_Works/How_It_Works";
import Benifits from "../../Common_Component/Benifits/Benifits";
import Why_Choose_Us from "./Why_Choose_Us/Why_Choose_Us";
import Get_In_Touch from "../All_services_inner/Video_Wala_Bus_Stand/Video_Wala_Bus_Stand_inner_content/Get_In_Touch/Get_In_Touch";
import Why_Should_Use from "./Why_Should_Use/Why_Should_Use";
import Banner from "./Banner/Banner";

const Digital_Media_Services_Inner = () => {
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [imgSrc, setImgSrc] = useState("");
  const { id } = useParams();

  const breadcrumbs = [
    { label: "Digital Media", link: "/services-inner/3", active: false },
    {
      label: data?.title || "Social Media Marketing", // Dynamically update label based on data
      link: "",
      active: true,
    },
  ];

  const social_media_data = [
    {
      id: 1,
      title: "Social Media Marketing",
      description:
        "Social Media Marketing is a dynamic and essential tool to connect with your audience, build brand awareness, and drive conversions. By leveraging platforms like Facebook, Instagram, LinkedIn, Twitter businesses can interact with their audience in real-time and create meaningful relationships.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/social_media/4.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/social_media/1.png",
      getInTouch_Title: "Ready to take ",
      getInTouch_Titl2: " your brand viral? ",
      getInTouch_Descn:
        "Let’s start a conversation and design a social media strategy that delivers! Call us today!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/digital_media.png",
      vidowala: false,
    },
    {
      id: 2,
      title: "Pay-Per-Click (PPC) Advertising",
      description:
        "Pay-Per-Click (PPC) Advertising is a powerful, results-driven way to get your brand noticed by the right audience at the right time. By placing your ads on platforms like Google and social media channels, PPC ensures you only pay when someone clicks on your ad. This precision-driven approach maximizes ROI and delivers measurable outcomes.",
      link: "",
      image1: "/Assets/Images/Service/Services/digital_media/PPC/1.png",
      image2: "/Assets/Images/Service/Services/digital_media/PPC/2.png",
      getInTouch_Title: "Want to boost your ",
      getInTouch_Titl2: "leads and sales instantly? ",
      getInTouch_Descn:
        "Let’s create a PPC strategy that delivers results. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/PPC.png",
      vidowala: false,
    },
    {
      id: 3,
      title: "Website Development & Optimization",
      description:
        "Your website is the digital storefront of your business. A professionally developed and optimized website not only enhances your online presence but also ensures your audience has a seamless experience, driving engagement, leads, and sales. Whether you need a new site or want to improve an existing one, our Website Development & Optimization services are designed to meet your unique needs.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/web_devlopment/1.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/web_devlopment/2.png",
      getInTouch_Title: "Ready to make a lasting  ",
      getInTouch_Titl2: "impression with your website?",
      getInTouch_Descn:
        "Let’s build a custom, high- performing site that drives results. Get in touch with us today!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/Website_Development.png",
      vidowala: false,
    },
    {
      id: 4,
      title: "Content Marketing",
      description:
        "Content Marketing is the art of creating valuable, relevant, and engaging content to attract, inform, and convert your target audience. From blog posts and infographics to videos content marketing positions your brand as an authority in your industry while driving organic traffic, building trust, and increasing conversions.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/Content_Marketing/1.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/Content_Marketing/3.png",
      getInTouch_Title: "Want to create content that  ",
      getInTouch_Titl2: "drives traffic, builds trust, and boosts sales? ",
      getInTouch_Descn:
        "Let’s build a content marketing strategy tailored to your goals. Contact us today!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/Content_Marketing.png",
      vidowala: false,
    },
    {
      id: 5,
      title: "Online Reputation Management",
      description:
        "Your online reputation can make or break your brand. Online Reputation Management (ORM) involves monitoring, improving, and maintaining how your business is perceived online. Whether it’s managing reviews, responding to customer feedback, or addressing negative publicity, ORM ensures your brand’s credibility and trustworthiness remain intact.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/Online_Reputation_Marketing/1.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/Online_Reputation_Marketing/2.png",
      getInTouch_Title: "Ready to build a  ",
      getInTouch_Titl2: "reputation that customers trust?",
      getInTouch_Descn:
        "Let us safeguard your online presence and elevate your brand. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/Online_Reputation_Management.png",
      vidowala: false,
    },



    {
      id: 6,
      title: "Search Engine Optimization (SEO)",
      description:
        "Search Engine Optimization (SEO) is the process of improving your website’s visibility on search engines like Google, Bing, and Yahoo. By optimizing your website’s structure, content, and technical aspects, SEO ensures your business appears at the top of search results when potential customers are looking for your products or services.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/Search_Engine_Optimization/1.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/Search_Engine_Optimization/2.png",
      getInTouch_Title: "Want to rank higher on  ",
      getInTouch_Titl2: "Google and attract more customers?",
      getInTouch_Descn:
        "Let’s create an SEO strategy tailored to your business. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/SEO.png",
      vidowala: false,
    },


    {
      id: 7,
      title: "Email Marketing",
      description:
        "Email Marketing remains one of the most effective and personalized ways to engage with your audience, nurture leads, and drive sales. By delivering tailored messages directly to your customers&#39; inboxes, you can build relationships, promote products or services, and encourage repeat business.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/Email_Marketing/1.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/Email_Marketing/2.png",
      getInTouch_Title: "Ready to boost engagement and drive  ",
      getInTouch_Titl2: "sales through email marketing?",
      getInTouch_Descn:
        "Let’s create a campaign tailored to your audience. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/Email_Marketing.png",
      vidowala: false,
    },

    
    {
      id: 8,
      title: "Influencer Marketing",
      description:
        "Influencer Marketing leverages the trust and connection influencers have with their followers to promote your brand. By collaborating with influencers across social media platforms like Instagram, YouTube, and blogs, you can reach your target audience authentically and build credibility.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/Influencer_Marketing/1.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/web_devlopment/2.png",
      getInTouch_Title: "Ready to harness the power of   ",
      getInTouch_Titl2: "influencers to grow your brand?",
      getInTouch_Descn:
        "Let’s create a campaign that connects you with your ideal audience. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/Influencer.png",
      vidowala: false,
    },



    
    {
      id: 9,
      title: "WhatsApp Bulk Messages",
      description:
        "WhatsApp Bulk Messaging is a direct and efficient way to reach your audience. With high open rates and personalized communication, it’s ideal for promoting your products, sharing updates, and engaging with customers.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/WhatsApp_Bulk_Messages/1.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/WhatsApp_Bulk_Messages/2.png",
      getInTouch_Title: "Ready to connect with your   ",
      getInTouch_Titl2: "audience instantly?",
      getInTouch_Descn:
        "Let us design a WhatsApp campaign that delivers real results. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/WhatsApp_Bulk.png",
      vidowala: false,
    },



    {
      id: 10,
      title: "SMS Bulk Messages",
      description:
        "SMS Bulk Messaging is a fast and reliable way to communicate with your audience. With unmatched open rates and the ability to reach a wide audience, it’s perfect for promotions, reminders, and updates that get noticed.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/web_devlopment/1.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/web_devlopment/2.png",
      getInTouch_Title: "Ready to deliver your message   ",
      getInTouch_Titl2: "directly to your audience?",
      getInTouch_Descn:
        "Let us create an SMS campaign that drives action and builds connections. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/SMS_Bulk.png",
      vidowala: false,
    },

    {
      id: 11,
      title: "Voice Calls / Missed Call System",
      description:
        "Voice Calls and Missed Call Systems are powerful tools for engaging with your audience in a personal and interactive way. They enable businesses to communicate important messages, capture leads, or provide customer service effectively.",
      link: "",
      image1:
        "/Assets/Images/Service/Services/digital_media/Voice_Calls/1.png",
      image2:
        "/Assets/Images/Service/Services/digital_media/web_devlopment/2.png",
      getInTouch_Title: "Ready to amplify  ",
      getInTouch_Titl2: "your communication? ",
      getInTouch_Descn:
        "Let us design a voice call or missed call campaign that engages your audience and drives results. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/Voice_Calls.png",
      vidowala: false,
    },

    
  ];


  

  useEffect(() => {
    const filteredArray = social_media_data.find(
      (item) => item.id === Number(id)
    );
    setData(filteredArray || {});

    const filteredArray2 = Why_Choose_us_data.find(
      (item) => item.id === Number(id)
    );
    setData2(filteredArray2 || {});

    const bannerImages = {
      1: "/Assets/Images/Service/Services/digital_media/Banner/banner1.png",
      2: "/Assets/Images/Service/Services/digital_media/Banner/banner2.png",
      3: "/Assets/Images/Service/Services/digital_media/Banner/banner3.png",
      4: "/Assets/Images/Service/Services/digital_media/Content_Marketing/Content_Marketing.png",
      5: "/Assets/Images/Service/Services/digital_media/Online_Reputation_Marketing/Online_Reputation_Marketing.png",
      6: "/Assets/Images/Service/Services/digital_media/Search_Engine_Optimization/SEO.png",
      7: "/Assets/Images/Service/Services/digital_media/Email_Marketing/Email_Marketing.png",
      8: "/Assets/Images/Service/Services/digital_media/Influencer_Marketing/Influencer_Marketing.png",
      9: "/Assets/Images/Service/Services/digital_media/WhatsApp_Bulk_Messages/WhatsApp_Bulk_Messages.png",
      10: "/Assets/Images/Service/Services/digital_media/SMS_Bulk_Messages/SMS_Bulk_Messages.png",
      11: "/Assets/Images/Service/Services/digital_media/Voice_Calls/Voice_Calls.png",
    };
    setImgSrc(
      bannerImages[id] ||
        "/Assets/Images/Service/Services/digital_media/Banner/banner1.png"
    );
  }, [id]);

  const Why_Choose_us_data = [
    {
      id: 1,
      text1:
        "We specialize in crafting innovative, results-driven social media campaigns that resonate with your audience. With expertise in creative content, ad management, and analytics, we’ll make your brand shine on every platform.",
      text2:
        " Ready to take your brand viral? Let’s start a conversation and design a social media strategy that delivers! Call us today!",
    },

    {
      id: 2,
      text1:
        " We specialize in delivering high-performing PPC campaigns tailored to your goals. With our expertise in keyword research, ad creation, and continuous optimization, we ensure maximum ROI and measurable success.",
      text2:
        " Want to boost your leads and sales instantly? Let’s create a PPC strategy that delivers, results. Contact us today to get started!",
    },

    {
      id: 3,
      text1:
        " Our team of web development experts combines creativity with cutting-edge technology to deliver high-quality websites. We focus on functionality, aesthetics, and optimization, ensuring your website not only looks great but also delivers results.",
      text2:
        " Ready to make a lasting impression with your website? Let’s build a custom, high- performing site that drives results. Get in touch with us today!",
    },

    {
      id: 4,
      text1:
        "We specialize in creating impactful content that aligns with your business objectives. Our team of skilled writers, designers, and strategists work together to craft content that not only captivates but also converts. From ideation to execution, we handle it all.",
      text2:
        "Want to create content that drives traffic, builds trust, and boosts sales? Let’s build a content marketing strategy tailored to your goals. Contact us today!",
    },

    {
      id: 5,
      text1:
        "Our ORM experts combine advanced monitoring tools with tailored strategies to help you control the narrative around your brand. With proactive solutions and personalized support, we ensure your online reputation reflects the quality and integrity of your business.",
      text2:
        "Ready to build a reputation that customers trust? Let us safeguard your online presence and elevate your brand. Contact us today to get started!",
    },

    {
      id: 6,
      text1:
        "Our team of SEO experts combines technical know-how with proven strategies to deliver measurable results. We stay up-to-date with the latest algorithm changes, ensuring your site ranks higher and stays ahead of the competition.",
      text2:
        "Want to rank higher on Google and attract more customers? Let’s create an SEO strategy tailored to your business. Contact us today to get started!",
    },

    {
      id: 7,
      text1:
        "We specialize in designing email campaigns that convert. From crafting compelling copy to leveraging data-driven strategies, our team ensures every email adds value to your customers and drives measurable results for your business.",
      text2:
        "Ready to boost engagement and drive sales through email marketing? Let’s create a campaign tailored to your audience. Contact us today to get started!",
    },

    {
      id: 8,
      text1:
        "We have a network of influencers across diverse niches and platforms, allowing us to connect your brand with the right voices. Our data-driven approach ensures that each campaign delivers maximum impact and measurable results.",
      text2:
        "Ready to harness the power of influencers to grow your brand? Let’s create a campaign that connects you with your ideal audience. Contact us today to get started!",
    },

    {
      id: 9,
      text1:
        "We specialize in creating customized WhatsApp campaigns that connect with your audience effectively. With expertise in segmentation, messaging strategy, and compliance, we ensure your campaigns are impactful and result-driven.",
      text2:
        "Ready to connect with your audience instantly? Let us design a WhatsApp campaign that delivers real results. Contact us today to get started!",
    },

    {
      id: 10,
      text1:
        "We bring expertise in crafting and managing SMS campaigns that deliver results. Our advanced tools, targeted strategies, and compliance-focused approach ensure every campaign achieves maximum impact.",
      text2:
        "Ready to deliver your message directly to your audience? Let us create an SMS campaign that drives action and builds connections. Contact us today to get started!",
    },

    {
      id: 11,
      text1:
        "We specialize in implementing voice call and missed call systems that are easy to use, scalable, and results-driven. Our solutions ensure maximum reach, seamless integration with your CRM, and compliance with telecommunication regulations.",
      text2:
        "Ready to amplify your communication? Let us design a voice call or missed call campaign that engages your audience and drives results. Contact us today to get started!",
    },
  ];

  return (
    <section className="Digital_Media_Services_Inner">
      <Banner imgSrc={imgSrc} />
      <Breadcrumbs_Holder breadcrumbs={breadcrumbs} />
      <Title_Component
        title={data?.title}
        description={data?.description}
        image1={data?.image1}
        image2={data?.image2}
      />
      <How_It_Works />
      {/* {id == 2 && <Why_Should_Use />} */}
      {(id === "2" || id === "5" || id === "6" || id === "9" || id === "10") && <Why_Should_Use />}
      <Benifits  />
      <Why_Choose_Us text1={data2?.text1} text2={data2?.text2} />
      <Get_In_Touch
        vidowala={data?.vidowala != undefined ? data?.vidowala : true}
        getInTouch_Img={data?.getInTouch_Img}
        getInTouch_Title={data?.getInTouch_Title}
        getInTouch_Titl2={data?.getInTouch_Titl2}
        getInTouch_Descn={data?.getInTouch_Descn}
      />
    </section>
  );
};

export default Digital_Media_Services_Inner;
